import React from 'react';
import FirstRouterLink from 'redux-first-router-link';

import { canvasContext } from 'utils/store/connect';

/**
 * Renders a redux-first-router-link that can access the canvas-store
 * @param {object} props - the props passed to this component
 * @returns {React.Component} the redux-first-router-link
 */
export const Link = props => <FirstRouterLink {...props} context={canvasContext} />;
